"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _react2 = require("../utils/react");
var _placement2 = _interopRequireWildcard(require("./placement"));
var _configProvider = require("../config-provider/configProvider");
var _helper = require("./helper");
var _utils = require("../utils");
var _excluded = ["message", "className", "style", "color", "size", "showArrow", "autoDestroy", "children", "placement", "autoAdjustOverflow", "align", "disabled", "delayShow", "prefixCls"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Tooltip组件的主体实现
var Tooltip = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  // 解构props，设置默认值
  var message = props.message,
    className = props.className,
    style = props.style,
    _props$color = props.color,
    color = _props$color === void 0 ? 'dark' : _props$color,
    _props$size = props.size,
    size = _props$size === void 0 ? 'normal' : _props$size,
    _props$showArrow = props.showArrow,
    showArrow = _props$showArrow === void 0 ? true : _props$showArrow,
    _props$autoDestroy = props.autoDestroy,
    autoDestroy = _props$autoDestroy === void 0 ? false : _props$autoDestroy,
    children = props.children,
    customPlacement = props.placement,
    _props$autoAdjustOver = props.autoAdjustOverflow,
    autoAdjustOverflow = _props$autoAdjustOver === void 0 ? true : _props$autoAdjustOver,
    align = props.align,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$delayShow = props.delayShow,
    delayShow = _props$delayShow === void 0 ? 100 : _props$delayShow,
    customizePrefixCls = props.prefixCls,
    otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  // 验证并设置placement
  var placement = (0, _placement2.isValidPlacement)(customPlacement) ? customPlacement : 'top';
  // 创建refs
  var triggerRef = (0, _react.useRef)(null);
  var popArrowRef = (0, _react.useRef)(null);
  // 获取配置上下文
  var _useContext = (0, _react.useContext)(_configProvider.ConfigContext),
    getPrefixCls = _useContext.getPrefixCls;
  var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
  /**
   * 处理对齐的函数
   */
  var handleAlign = function handleAlign(_align, popNode, targetEl) {
    var onAlign = props.onAlign;
    // 如果提供了onAlign回调，则调用它
    if ((0, _utils.isFunction)(onAlign)) {
      onAlign(_align, popNode, targetEl);
    }
    var popLayerContainer = triggerRef.current.popRef.current.popLayerContainer;
    var arrowNode = popArrowRef.current;
    var targetNode = targetEl;
    if (popNode && arrowNode && targetNode) {
      var windowViewport = (0, _helper.getViewport)(window);
      var viewport = (0, _helper.getViewport)(popLayerContainer);
      // 判断popNode是否到达popLayerContainer或者viewport的边界
      var reachedLimit = (0, _helper.isReachLimit)(popNode, windowViewport, {
        targetNode: targetNode,
        popNodeAlign: _align
      }) || (0, _helper.isReachLimit)(popNode, viewport, {
        targetNode: targetNode,
        popNodeAlign: _align
      });
      var needJsAlign = false; // 是否需要js定位
      if (arrowNode) {
        var arrowAlign = {
          points: ['', '']
        }; // 默认没定位
        var direction = '';
        var isCorner = (0, _placement2.isCornerPlacement)(placement); // placement是否为topLeft等8个边角
        // popNode达到边界
        if (reachedLimit) {
          /*
           * 调整定位
           * [arrowAlign, direction] = adjustArrowAlign(align, { windowViewport, viewport, targetNode });
           * domAlign(arrowNode, targetNode, arrowAlign);
           */
          /*
           * 调整class
           * this.adjustClass(arrowAlign, arrowNode, reachedLimit);
           */
          var _arrowDomAlign = (0, _helper.arrowDomAlign)(_align, {
            windowViewport: windowViewport,
            viewport: viewport,
            targetNode: targetNode,
            arrowNode: arrowNode
          });
          var _arrowDomAlign2 = (0, _slicedToArray2.default)(_arrowDomAlign, 2);
          arrowAlign = _arrowDomAlign2[0];
          direction = _arrowDomAlign2[1];
        } else {
          // 清空style，保持原有逻辑
          arrowNode.style.left = '';
          arrowNode.style.right = '';
          arrowNode.style.top = '';
          arrowNode.style.bottom = '';
          // 当为边角定位时：考虑不临界但target小于边角的的状况，tt：https://tt.sankuai.com/ticket/detail?id=61429517
          if (isCorner && (0, _helper.isCornerNeedAlign)(_align, targetNode)) {
            var _arrowDomAlign3 = (0, _helper.arrowDomAlign)(_align, {
              windowViewport: windowViewport,
              viewport: viewport,
              targetNode: targetNode,
              arrowNode: arrowNode
            });
            var _arrowDomAlign4 = (0, _slicedToArray2.default)(_arrowDomAlign3, 2);
            arrowAlign = _arrowDomAlign4[0];
            direction = _arrowDomAlign4[1];
            needJsAlign = true;
          }
        }
        adjustClass(arrowAlign, arrowNode, reachedLimit || needJsAlign); // 当reachedLimit时给arrow加上reachLimit类
        /*
         * TODO: dom-align定位可能会导致arrow内陷或外凸，暂时先通过css定位解决
         * 去掉dom-align定位添加的left或top属性即可
         */
        if (direction) {
          if (direction === 'l' || direction === 'r') arrowNode.style.left = '';else if (direction === 't' || direction === 'b') arrowNode.style.top = '';
        }
      }
      // 调整popNode的class
      adjustClass(_align, popNode);
    }
  };
  /**
   * 获取对齐配置
   */
  var getAlignConfig = function getAlignConfig() {
    var placements = (0, _placement2.default)({
      autoAdjustOverflow: autoAdjustOverflow
    });
    return _objectSpread(_objectSpread({}, placements[placement]), align);
  };
  /**
   * 获取对齐后的popup类名
   */
  var getAlignPopupClassName = function getAlignPopupClassName(_align) {
    var points = _align.points;
    var builtinPlacements = (0, _placement2.default)({
      verticalArrowShift: 8,
      autoAdjustOverflow: autoAdjustOverflow
    });
    var cls = '';
    Object.keys(builtinPlacements).forEach(function (_placement) {
      if ((0, _react2.isPointsEq)(builtinPlacements[_placement].points, points)) {
        cls = "".concat(prefixCls, "-placement-").concat(_placement);
      }
    });
    return cls;
  };
  /**
   * 为popup添加class
   */
  var adjustClass = function adjustClass(_align, popNode) {
    var alignByJs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _placementCls = getAlignPopupClassName(_align);
    var reg = new RegExp("^".concat(prefixCls, "-placement-\\w+"));
    var limitReg = new RegExp("^".concat(prefixCls, "-alignjs"));
    Array.prototype.forEach.call(popNode.classList, function (cln) {
      if (reg.test(cln)) {
        popNode.classList.remove(cln);
      }
      if (!alignByJs && limitReg.test(cln)) {
        popNode.classList.remove(cln);
      }
    });
    _placementCls && popNode.classList.add(_placementCls);
    alignByJs && popNode.classList.add("".concat(prefixCls, "-alignjs"));
  };
  /**
   * 对外提供重新计算位置的方法
   * 解决自身内容高度变化需要重新计算位置
   */
  var forceAlign = function forceAlign() {
    if (triggerRef.current && triggerRef.current.forceAlign) {
      triggerRef.current.forceAlign();
    }
  };
  /**
   * 设置PopLayer的可见性
   */
  var setPopLayerVisible = function setPopLayerVisible(visible) {
    if (triggerRef.current && triggerRef.current.setPopLayerVisible) {
      triggerRef.current.setPopLayerVisible(visible);
    }
  };
  // 使用 useImperativeHandle 暴露方法
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      forceAlign: forceAlign,
      setPopLayerVisible: setPopLayerVisible
    };
  });
  /**
   * 渲染弹出层内容
   */
  var renderPopup = function renderPopup() {
    var tooltipCls = (0, _classnames2.default)(prefixCls, className, "".concat(prefixCls, "-").concat(color), (0, _defineProperty2.default)({}, "".concat(prefixCls, "-sm"), size === 'small'));
    return /*#__PURE__*/_react.default.createElement("div", {
      className: tooltipCls,
      style: style
    }, (!!message || (0, _utils.isNumber)(message) || (0, _utils.isFunction)(message)) && ( /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showArrow && ( /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-arrow"),
      ref: popArrowRef
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-inner")
    }, (0, _utils.isFunction)(message) ? message() : message))));
  };
  // 返回Trigger组件
  return /*#__PURE__*/_react.default.createElement(_react2.Trigger, _objectSpread(_objectSpread({}, otherProps), {}, {
    delayShow: delayShow,
    ref: triggerRef,
    popup: renderPopup(),
    align: getAlignConfig(),
    onAlign: handleAlign,
    autoDestroy: autoDestroy,
    disabled: disabled
  }), /*#__PURE__*/_react.default.isValidElement(children) ? children : /*#__PURE__*/_react.default.createElement("span", null, children));
});
Tooltip.displayName = 'Tooltip';
var _default = exports.default = Tooltip;